import React, { Component } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormGroup,
  Checkbox,
  Typography,
  Box
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { 
  obtenerValores, 
  obtenerPermisosValor, 
  formulario,
  mostrarError 
} from '../../global/js/funciones';
import { 
  PREGUNTA_ENCUESTA_REGISTRO_ACOMPANAMIENTO,
  PREGUNTA_GRUPO_PRIORIZADO,
  RESPUESTA_GRUPO_PRIORIZADO,
  PREGUNTA_TIPO_CASO,
  RESPUESTA_OTROS,
  RESPUESTA_NINGUNO
} from './helper';

const styles = (theme) => ({
  compactModal: {
    '& .MuiDialog-paper': {
      margin: theme.spacing(1),
      maxHeight: '90vh',
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(0.5),
        maxHeight: '95vh'
      }
    }
  },
  modalTitle: {
    backgroundColor: '#B70E0C',
    color: 'white',
    padding: theme.spacing(1.5, 2),
    '& .MuiTypography-root': {
      fontSize: '1.1rem',
      fontWeight: 600
    }
  },
  modalContent: {
    padding: theme.spacing(1.5, 2),
    '& .MuiBox-root': {
      marginBottom: theme.spacing(1.5)
    }
  },
  questionTitle: {
    fontSize: '0.9rem',
    fontWeight: 500,
    marginBottom: theme.spacing(0.5),
    color: '#333'
  },
  compactFormGroup: {
    '& .MuiFormControlLabel-root': {
      marginBottom: theme.spacing(0.25),
      '& .MuiTypography-root': {
        fontSize: '0.85rem'
      }
    }
  },
  compactTextField: {
    '& .MuiInputBase-root': {
      fontSize: '0.9rem'
    },
    '& .MuiInputLabel-root': {
      fontSize: '0.9rem'
    }
  },
  modalActions: {
    padding: theme.spacing(1, 2),
    backgroundColor: '#f8f9fa',
    '& .MuiButton-root': {
      minWidth: 80,
      fontSize: '0.85rem'
    }
  }
});

class RegistroAcompanamientoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: false,
      respuestas: {},
      preguntasFormateadas: []
    };
  }

  componentDidMount() {
    this.cargarPreguntas();
  }

  cargarPreguntas = async () => {
    try {
      this.setState({ cargando: true });

      const transformar = (data) => {
        return data.map((item) => ({
          id: item.id,
          nombre: item.nombre,
          tipo: item.valora,
          posicion: item.valorc,
          obligatorio: Boolean(item.valorb),
          condicion: item.valord
        }));
      };

      const transformarRespuestas = (datos) => {
        let respuestas = [];
        datos.map(({ secundario, principal }) => {
          let { id, nombre, valorb } = secundario;
          respuestas.push({
            id: id,
            nombre: `${nombre}`,
            posicion: valorb,
            id_pregunta: principal.id
          });
          return true;
        });
        return respuestas;
      };

      let preguntasAPI = await obtenerValores(PREGUNTA_ENCUESTA_REGISTRO_ACOMPANAMIENTO);
      preguntasAPI.sort((a, b) => (a.valorc > b.valorc ? 1 : -1));
      preguntasAPI = transformar(preguntasAPI);

      let respuestasAcumuladas = [];
      for (const { id } of preguntasAPI) {
        let preguntasResp = await obtenerPermisosValor(id);
        preguntasResp.sort((a, b) =>
          parseInt(a.secundario.valorb) > parseInt(b.secundario.valorb) ? 1 : -1
        );

        let respuestasTemp = [];
        respuestasTemp.push(transformarRespuestas(preguntasResp));
        respuestasAcumuladas.push(respuestasTemp);
      }

      const preguntasFormateadas = preguntasAPI.map(pregunta => {
        const respuestasPregunta = respuestasAcumuladas
          .flat(2)
          .filter(respuesta => respuesta.id_pregunta === pregunta.id)
          .sort((a, b) => parseInt(a.posicion) - parseInt(b.posicion));

        return {
          ...pregunta,
          respuestas: respuestasPregunta
        };
      }).sort((a, b) => parseInt(a.posicion) - parseInt(b.posicion));

      this.setState({
        preguntasFormateadas,
        cargando: false
      });

    } catch (error) {
      this.setState({ cargando: false });
      console.error('Error cargando preguntas:', error);
    }
  };

  obtenerPreguntasVisibles = () => {
    const { preguntasFormateadas, respuestas } = this.state;
    
    let preguntasVisibles = preguntasFormateadas.filter(p => p.id === PREGUNTA_GRUPO_PRIORIZADO);
    
    if (respuestas[PREGUNTA_GRUPO_PRIORIZADO]) {
      if (respuestas[PREGUNTA_GRUPO_PRIORIZADO] !== RESPUESTA_GRUPO_PRIORIZADO) {
        preguntasVisibles = preguntasFormateadas.filter(p => p.id !== PREGUNTA_GRUPO_PRIORIZADO);
        preguntasVisibles.unshift(preguntasFormateadas.find(p => p.id === PREGUNTA_GRUPO_PRIORIZADO));
      } else {
        preguntasVisibles = preguntasFormateadas.filter(p => p.id !== PREGUNTA_TIPO_CASO);
      }
    }
    
    return preguntasVisibles;
  };

  handleRespuestaChange = (preguntaId, valor) => {
    this.setState({
      respuestas: {
        ...this.state.respuestas,
        [preguntaId]: valor
      }
    });
  };

  handleCheckboxChange = (preguntaId, respuestaId, checked) => {
    const respuestasActuales = this.state.respuestas[preguntaId] || [];
    let nuevasRespuestas;

    if (checked) {
      nuevasRespuestas = [...respuestasActuales, respuestaId];
    } else {
      nuevasRespuestas = respuestasActuales.filter(id => id !== respuestaId);
    }

    this.setState({
      respuestas: {
        ...this.state.respuestas,
        [preguntaId]: nuevasRespuestas
      }
    });
  };

  renderPregunta = (pregunta) => {
    const { classes } = this.props;
    const { respuestas } = this.state;
    const valorSeleccionado = respuestas[pregunta.id];

    switch (pregunta.tipo) {
      case 'radio':
        return (
          <div key={pregunta.id}>
            <FormControl component="fieldset" fullWidth required={pregunta.obligatorio}>
              <Typography className={classes.questionTitle}>
                {pregunta.nombre} {pregunta.obligatorio && '*'}
              </Typography>
              <RadioGroup
                value={valorSeleccionado ? valorSeleccionado.toString() : ''}
                onChange={(e) => this.handleRespuestaChange(pregunta.id, parseInt(e.target.value))}
                className={classes.compactFormGroup}
              >
                {pregunta.respuestas.map((respuesta) => (
                  <FormControlLabel
                    key={respuesta.id}
                    value={respuesta.id.toString()}
                    control={<Radio size="small" />}
                    label={respuesta.nombre}
                  />
                ))}
              </RadioGroup>
            </FormControl>
            {valorSeleccionado === RESPUESTA_OTROS && (
              <TextField
                fullWidth
                multiline
                rows={2}
                value={respuestas[`otro_${pregunta.id}`] || ''}
                onChange={(e) => this.handleRespuestaChange(`otro_${pregunta.id}`, e.target.value)}
                placeholder="Especifique..."
                variant="outlined"
                size="small"
                className={classes.compactTextField}
                required
              />
            )}
          </div>
        );

      case 'checkbox':
        return (
          <div key={pregunta.id}>
            <FormControl component="fieldset" fullWidth required={pregunta.obligatorio}>
              <Typography className={classes.questionTitle}>
                {pregunta.nombre} {pregunta.obligatorio && '*'}
              </Typography>
              <FormGroup className={classes.compactFormGroup}>
                {pregunta.respuestas.map((respuesta) => (
                  <FormControlLabel
                    key={respuesta.id}
                    control={
                      <Checkbox
                        size="small"
                        checked={(respuestas[pregunta.id] || []).includes(respuesta.id)}
                        onChange={(e) => this.handleCheckboxChange(pregunta.id, respuesta.id, e.target.checked)}
                      />
                    }
                    label={respuesta.nombre}
                  />
                ))}
              </FormGroup>
            </FormControl>
            {(respuestas[pregunta.id] || []).includes(RESPUESTA_OTROS) && (
              <TextField
                fullWidth
                multiline
                rows={2}
                value={respuestas[`otro_${pregunta.id}`] || ''}
                onChange={(e) => this.handleRespuestaChange(`otro_${pregunta.id}`, e.target.value)}
                placeholder="Especifique..."
                variant="outlined"
                size="small"
                className={classes.compactTextField}
                required
              />
            )}
          </div>
        );

      case 'texto':
        return (
          <TextField
            key={pregunta.id}
            label={`${pregunta.nombre} ${pregunta.obligatorio ? '*' : ''}`}
            multiline
            rows={3}
            value={respuestas[pregunta.id] || ''}
            onChange={(e) => this.handleRespuestaChange(pregunta.id, e.target.value)}
            fullWidth
            required={pregunta.obligatorio}
            variant="outlined"
            size="small"
            className={classes.compactTextField}
          />
        );

      default:
        return null;
    }
  };

  validarRespuestas = () => {
    const { respuestas, preguntasFormateadas } = this.state;

    if (!preguntasFormateadas || preguntasFormateadas.length === 0) return false;

    const preguntasVisibles = this.obtenerPreguntasVisibles();

    for (const pregunta of preguntasVisibles) {
      if (pregunta.obligatorio) {
        const respuesta = respuestas[pregunta.id];

        if (!respuesta) return false;
        
        if (pregunta.tipo === 'checkbox' && Array.isArray(respuesta) && respuesta.length === 0) return false;

        if (pregunta.tipo === 'texto' && !respuesta.trim()) return false;
      }
    }

    return true;
  };

  guardarRespuestas = async () => {
    if (!this.validarRespuestas()) {
      this.props.actualizarMensaje({ titulo: 'Por favor complete todos los campos obligatorios', tipo: 'warning', mostrar: true, tiempo: 4000 });
      return;
    }

    const { estudiante, onActualizar, cantidadEstudiantes } = this.props;
    const { respuestas, preguntasFormateadas } = this.state;
    console.log(cantidadEstudiantes)
    this.setState({ cargando: true });

    try {
      const data = new FormData();
      
      // Datos del estudiante
      data.append('estudiante_id', estudiante.id);
      data.append('cedula_estudiante', estudiante.cedula_estudiante_acompanamiento);
      data.append('cantidad_estudiantes_restantes', (cantidadEstudiantes || 0) - 1);

      // Crear objeto con respuestas formateadas
      const respuestasFormateadas = {
        verificacion_grupo: null,
        descripcion_general: "",
        seguimiento_realizado: "",
        clasificacion_casos: [RESPUESTA_NINGUNO],
        requiere_remi: null
      };

      // Mapear respuestas
      preguntasFormateadas.forEach(pregunta => {
        const respuesta = respuestas[pregunta.id];

        if (pregunta.nombre.toLowerCase().includes('descripción general') ||
            pregunta.nombre.toLowerCase().includes('descripcion general')) {
          if (respuesta) {
            respuestasFormateadas.descripcion_general = respuesta;
          }
        }
        else if (pregunta.nombre.toLowerCase().includes('describa seguimiento')) {
          respuestasFormateadas.seguimiento_realizado = respuesta || '';
        }
        else if (pregunta.nombre.toLowerCase().includes('requiere remisión') ||
                 pregunta.nombre.toLowerCase().includes('requiere remision') ||
                 pregunta.nombre.toLowerCase().includes('remitido')) {
          if (respuesta) {
            respuestasFormateadas.requiere_remi = respuesta;
          }
        }
        else if (pregunta.nombre.toLowerCase().includes('priorizado')) {
          if (respuesta) {
            respuestasFormateadas.verificacion_grupo = respuesta;
          }
        }
        else if (pregunta.nombre.toLowerCase().includes('tipo de caso')) {
          if (Array.isArray(respuesta) && respuesta.length > 0) {
            respuestasFormateadas.clasificacion_casos = respuesta;
          }
        }
      });

      // Verificar observaciones de "Otro"
      preguntasFormateadas.forEach(pregunta => {
        const respuesta = respuestas[pregunta.id];
        const observacionOtro = respuestas[`otro_${pregunta.id}`];

        if (observacionOtro) {
          if (pregunta.tipo === 'radio' && respuesta === RESPUESTA_OTROS) {
            respuestasFormateadas.otro_tipo_caso = observacionOtro;
          }
          else if (pregunta.tipo === 'checkbox' && Array.isArray(respuesta) && respuesta.includes(RESPUESTA_OTROS)) {
            respuestasFormateadas.otro_tipo_caso = observacionOtro;
          }
        }
      });

      if (respuestasFormateadas.verificacion_grupo === null) {
        respuestasFormateadas.verificacion_grupo = 1;
      }

      data.append('respuestas', JSON.stringify(respuestasFormateadas));

      formulario(`api/v1.0/acompanamiento_docente/estudiante/actualizar`, data, "patch", (error, estado, resp) => {
        this.setState({ cargando: false });
        
        if (!error && estado === 200) {
          this.props.actualizarMensaje({ titulo: 'Registro actualizado correctamente', tipo: 'success', mostrar: true, tiempo: 4000 });
          // Limpiar los campos después de guardar exitosamente
          this.setState({ respuestas: {} });
          if (onActualizar) onActualizar();
        } else {
          const mensaje = resp?.titulo || mostrarError(resp) || 'Error al actualizar el registro';
          this.props.actualizarMensaje({ titulo: mensaje, tipo: 'error', mostrar: true, tiempo: 4000 });
        }
      });

    } catch (error) {
      this.setState({ cargando: false });
      this.props.actualizarMensaje({ titulo: 'Error al procesar la solicitud', tipo: 'error', mostrar: true, tiempo: 4000 });
    }
  };

  render() {
    const { classes, open, onClose, estudiante } = this.props;
    const { cargando } = this.state;

    if (!estudiante) return null;

    return (
      <Dialog
        open={open}
        maxWidth="sm"
        fullWidth
        className={classes.compactModal}
        scroll="body"
        onClose={onClose}
      >
        <DialogTitle className={classes.modalTitle}>
          Registro de Acompañamiento
        </DialogTitle>
        <DialogContent className={classes.modalContent}>
          <Box mb={2} p={1.5} bgcolor="#f8f9fa" borderRadius={1}>
            <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#B70E0C' }}>
              {estudiante.estudiante_acompanamiento ? 
                `${estudiante.estudiante_acompanamiento.primer_nombre} ${estudiante.estudiante_acompanamiento.primer_apellido}` : 
                'Estudiante'
              }
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Cédula: {estudiante.cedula_estudiante_acompanamiento || 'N/A'}
            </Typography>
          </Box>

          {this.obtenerPreguntasVisibles().map((pregunta) => (
            <Box key={pregunta.id} mb={2}>
              {this.renderPregunta(pregunta)}
            </Box>
          ))}
        </DialogContent>
        <DialogActions className={classes.modalActions}>
          <Button
            onClick={onClose}
            size="small"
            disabled={cargando}
          >
            Cancelar
          </Button>
          <Button
            onClick={this.guardarRespuestas}
            color="primary"
            variant="contained"
            size="small"
            disabled={cargando}
          >
            {cargando ? 'Guardando...' : 'Guardar'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(RegistroAcompanamientoModal);